import React from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Button } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const KeyboardUtil = require('../../util/keyboard');
const SignInStore = require('../../stores/SignInStore');
const OrganizationStore = require('../../stores/OrganizationStore');
const OrganizationActions = require('../../actions/OrganizationActions');
const ValidateUtil = require('../../util/ValidateUtil');
const UriUtil = require('../../util/UriUtil');
import Navigator from '../../Navigator';
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import SignInFormNew from '../common/SignInFormNew';
import { SignedOutVerifyOrgPanel } from './SignedOutPromoPanel';

const propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

class ValidateOrganization extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationStoreState: OrganizationStore.getState(),
            signinStoreState: SignInStore.getState(),
            displayName: "",
            password: "",
            passwordConfirm: "",
            registrationComplete: false,
            message: "",
            key: "",
            actionID: null,
            uiErrors: {},
            infoActionId: null,
            haveOrgInfo: false,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.passwordOnChange = this.passwordOnChange.bind(this);
        this.passwordConfirmOnChange = this.passwordConfirmOnChange.bind(this);
        this.dispNameOnChange = this.dispNameOnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.registerHandler = this.registerHandler.bind(this);
        this.unsubscribes = [
            OrganizationStore.listen(this.onOrganizationStoreChange.bind(this)),
            SignInStore.listen(this.onSignInStoreChange.bind(this))
        ];
    }

    componentDidMount(){
        const key = UriUtil.parseLocationSearchString(this.props.location).key;
        if (!key) {
            this.props.history.replace('/signin');
            return;
        }

        const infoActionId = uuid.v4();
        this.setState({ infoActionId: infoActionId }, () => {
            OrganizationActions.orgInfo(infoActionId, { secret: key });
        });

    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSignInStoreChange(state) {
        if (this.state.registrationComplete && state.initializedLocal) {
            // this.props.history.push('/dashboard/' + state.userInfo.id);
            // return;
        }

        this.setState({ signinStoreState: state });
    }

    onOrganizationStoreChange(state) {
        let additionalState = {};
        if (!!state.action.id && [this.state.infoActionId, this.state.actionID].indexOf(state.action.id) >= 0) {
            if (state.action.id === this.state.infoActionId) {
                additionalState = {
                    ...additionalState,
                    infoActionId: null,
                };

                if (!state.action.error) {
                    //org info received
                    additionalState = { ...additionalState, haveOrgInfo: true, displayName: state.orgInfo.display_name };
                }
                else {
                    additionalState = { ...additionalState, error: state.action.error };
                }
            }
            else if (state.action.id === this.state.actionID) {
                additionalState = {
                    ...additionalState,
                    ...ValidateUtil.getUpdatedState(this.state.actionID, state, true),
                    actionID: null,
                };

                if (!state.action.error) {
                    //registration completed
                    if (this.state.signinStoreState.initializedLocal) { //transition to dashboard if signed in
                        Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.state.signinStoreState.userInfo.id, { replace: true });
                        return;
                    }
                    else { //request sign in as org admin
                        additionalState = { ...additionalState, actionID: null, registrationComplete: true };
                    }
                }
                else {
                    let uiErrors = {};
                    if (state.action.error.uiRefs) {
                        state.action.error.uiRefs.forEach((ref) => {
                            uiErrors[ref] = true;
                        });
                    }
                    
                    additionalState = { ...additionalState, error: state.action.error, uiErrors: uiErrors };
                }

            }
        }

        this.setState({ organizationStoreState: state, ...additionalState });
    }

    passwordOnChange(e) {
        this.setState({ password: e.target.value });
    }

    passwordConfirmOnChange(e) {
        this.setState({ passwordConfirm: e.target.value });
    }

    dispNameOnChange(e) {
        this.setState({ displayName: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.registerHandler();
        }
    }

    registerHandler() {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            OrganizationActions.validateOrganization(actionID, {
                secret: UriUtil.parseLocationSearchString(this.props.location).key,
                displayName: this.state.displayName,
                password: this.state.password,
                passwordConfirm: this.state.passwordConfirm
            });
        });
    }

    render() {
        return (
            <div className="fill signed-out--new">
                <div className="container rel-centered-v">
                    <div className="signedOutDual">
                        <SignedOutVerifyOrgPanel />
                        <div className="signedOutDual__form">
                            <ErrorBox error={this.state.error} />
                            {(!this.state.haveOrgInfo) ?
                                (!!this.state.infoActionId) ?
                                    <LoadingMainContent />
                                    :
                                    null
                                :
                                !this.state.registrationComplete ?
                                    <Form>
                                        <Row>
                                            <div className="col-12">
                                                <Form.Group controlId="register-disp-name">
                                                    <Form.Label>{Strings['en'].signed_out.register_new.DISP_ORG_LBL}</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        aria-label={Strings['en'].signed_out.register_new.DISP_ORG_LBL}
                                                        placeholder={Strings['en'].signed_out.register_new.DISP_ORG_PH}
                                                        value={this.state.displayName}
                                                        onChange={this.dispNameOnChange}
                                                        onKeyDown={this.handleKeyDown}
                                                        isInvalid={ValidateUtil.isInvalid(this.state, 'displayName')}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="col-12 col-sm-6">
                                                <Form.Group controlId="register-password">
                                                    <Form.Label>{Strings['en'].signed_out.register_new.PW_LBL}</Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        aria-label={Strings['en'].signed_out.register_new.PW_LBL}
                                                        placeholder={Strings['en'].signed_out.register_new.PW_PH}
                                                        value={this.state.password}
                                                        onChange={this.passwordOnChange}
                                                        onKeyDown={this.handleKeyDown}
                                                        isInvalid={ValidateUtil.isInvalid(this.state, 'password')}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <Form.Group controlId="register-password-confirm">
                                                    <Form.Label>{Strings['en'].signed_out.register_new.PW_CONFIRM_LBL}</Form.Label>
                                                    <Form.Control
                                                        type="password"
                                                        aria-label={Strings['en'].signed_out.register_new.PW_CONFIRM_LBL}
                                                        placeholder={Strings['en'].signed_out.register_new.PW_CONFIRM_PH}
                                                        value={this.state.passwordConfirm}
                                                        onChange={this.passwordConfirmOnChange}
                                                        onKeyDown={this.handleKeyDown}
                                                        isInvalid={ValidateUtil.isInvalid(this.state, 'passwordConfirm')}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Row>
                                        <div className="signedOutDual__buttonRow margin-top-lg">
                                            <Button
                                                className="btn-register-full"
                                                disabled={this.state.registrationComplete || !!this.state.actionID}
                                                onClick={this.registerHandler}
                                            >
                                                {Strings['en'].signed_out.register_new.VERIFY_BTN_LBL}
                                            </Button>
                                        </div>
                                    </Form>
                                    :
                                    <div>
                                        <SuccessBox>
                                            {Strings['en'].signed_out.register_new.ORG_REG_COMPLETE}
                                            <p className="margin-top-md">{Strings['en'].signed_out.register_new.ORG_REG_COMPLETE_SIGN_IN_PROMPT}</p>
                                        </SuccessBox>
                                        <SignInFormNew forceTransition />
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

ValidateOrganization.propTypes = propTypes;
ValidateOrganization.defaultProps = defaultProps;

export default withRouter(ValidateOrganization);